import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import HorseForm from "../HorseForm";
import { HorseSchema } from "../Schema";
import { img_upload_base_path } from "constants/constants";
import { useModalStore } from "stores/modal/useModalStore";
import { useHorseStore } from "stores/horse/useHorseStore";
import OwnershipEmailForm from "../AddHorse/OwnershipEmailForm";
import ModalStore from "components/Modal/ModalStore";

export const EditHorse = () => {
  const close = useModalStore((s) => s.close);

  const horseData = useHorseStore((state) => state.horseData);
  const updateHorseError = useHorseStore((state) => state.updateHorseError);
  const isHorseUpdating = useHorseStore((state) => state.isHorseUpdating);

  const updateHorse = useHorseStore((action) => action.updateHorse);
  const setIsHorseUpdating = useHorseStore((action) => action.setIsHorseUpdating);
  const refetchListDisciplines = useHorseStore((action) => action.refetchListDisciplines);

  const extractedPhoto = horseData?.photo?.includes("/public")
    ? horseData.photo.split("/public")[1]?.slice(1)
    : "";

  const methods = useForm({
    resolver: zodResolver(HorseSchema),
    defaultValues: {
      name: horseData?.name || "",
      dob: horseData?.dob || "",
      photo: extractedPhoto || horseData?.photo || "",
      discipline: horseData?.discipline || [],
      registeredName: horseData?.registeredName,
    },
  });

  useEffect(() => {
    refetchListDisciplines();
  }, [refetchListDisciplines]);

  const onSubmit = async (data) => {
    setIsHorseUpdating(true);

    const disciplineArr = data?.discipline || [];

    const photo = data?.photo ? `${img_upload_base_path}${data.photo}` : null;

    const input_horse_data = {
      name: data?.name,
      dob: data?.dob,
      discipline: disciplineArr,
      ...(photo ? { photo } : {}),
    };

    try {
      await updateHorse({
        input: { ...input_horse_data, id: horseData?.id },
      });
      ModalStore.openSimpleSuccess({
        title: "SUCCESS!",
        subtitle: "This horse profile has been updated",
        shouldCloseOnOverlayClick: false,
      });

      close();
    } catch (error) {
      close();
      const errorHandlers = {
        "Please Verify Your Ownership": () => {
          ModalStore.openSimpleSuccess({
            icon: undefined,
            fontSize: "40px",
            title: "Please Verify Your Ownership",
            shouldCloseOnOverlayClick: false,
            children: <OwnershipEmailForm inputHorseData={input_horse_data} />
          });
        },
        "Already Registered Horse With Owner": () => {
          ModalStore.openSimpleError({
            fontSize: "40px",
            title: "Already Registered Horse With Owner",
            subtitle: "",
            shouldCloseOnOverlayClick: false,
          });
        },
        default: () => {
          ModalStore.openSimpleError({
            fontSize: "40px",
            title: "An Unexpected Error Occurred",
            description: error?.message || "Unknown error.",
            shouldCloseOnOverlayClick: false,
          });
        },
      };

      (errorHandlers[error?.message] || errorHandlers.default)();
    } finally {
      setIsHorseUpdating(false);
      if (updateHorseError?.message !== "Please Verify Your Ownership") {
        close();
      }
    }
  };

  return (
    <HorseForm
      onSubmit={onSubmit}
      methods={methods}
      onCancel={close}
      isLoading={isHorseUpdating}
      defaultImage={horseData.photo}
    />
  );
};
